import { IReqResponseCode, IReqResponseMode } from '../lib/config';
export interface IResponseHeaders {
  code: IReqResponseCode;
  mode?: IReqResponseMode;
  field?: string;
}

export enum IRequestType {
  XHR = 1,
  Fetch = 2,
}

export interface IEncryptApi {
  api: string;
  method: string[];
}
